import { z } from "../wire/zod";

export const getCompanyLicenseResponseSchema = z.object({
  license: z.object({
    isValid: z.boolean().describe("License string has a valid format (always true on cloud)"),
    isExpired: z.boolean(),
    usedTeamLicenses: z.number().int(),
    numberOfTeams: z.number().int(),
    expiryDate: z.string().date(),
    sso: z.boolean(),
    tracking: z.boolean(),
    onprem: z.boolean().describe("Cloud only: this cloud account belongs to an on-prem customer"),
    plan: z
      .enum(["standard", "premium", "enterprise"])
      .describe("Absent for on-prem licenses, which carry no plan")
      .optional(),
    type: z.enum(["trial", "customer", "partner", "internal", "expired", "trial_expired"]),
    limitedExternalTeams: z.boolean(),
    limitedExternalSwimlanes: z.boolean(),
  }),
});
export const getCompanyResponseSchema = z.object({
  company: z.object({ id: z.string(), name: z.string(), shouldOnboard: z.boolean() }),
});
export const getCompanySettingsResponseSchema = z.object({
  settings: z.object({
    autoLogoutAfter: z
      .number()
      .int()
      .gte(0)
      .describe("Minutes of inactivity before automatic logout; 0 or absent disables it")
      .optional(),
  }),
});
export const updateCompanyResponseSchema = z.object({
  company: z.object({ id: z.string(), name: z.string(), shouldOnboard: z.boolean() }),
});
